export default [
  { label: 'Template #1', value: 'SignatureTemplate1' },
  { label: 'Template #2', value: 'SignatureTemplate2' }
]
